/* eslint-disable react/prop-types */
import clsx from 'clsx';
import React from 'react';
import { Message, SortingComponent, Visible } from 'src/core/components';

import {
  ActionsCell,
  ProductDescription,
  ProductStatus,
  SelectAll,
  SelectOne,
} from './components';
import messages from './messages';

export default ({
  addProductId,
  removeProductId,
  setSelectedItems,
  productsIds,
  selectedProductsIds,
  isViewAllActive,
  handleSorting,
  sortPayload,
}) => [
  {
    Header: (
      <Visible when={!isViewAllActive && productsIds.length}>
        <SelectAll
          {...{
            itemsIds: productsIds,
            selectedItemsIds: selectedProductsIds,
            setSelectedItems,
          }}
        />
      </Visible>
    ),
    accessor: 'checkbox',
    Cell: (props) => (
      <SelectOne
        {...{
          ...props,
          addItem: addProductId,
          removeItem: removeProductId,
          selectedItemsIds: selectedProductsIds,
        }}
      />
    ),
  },
  {
    Header: (
      <>
        <Message message={messages.nameAndDescription} literal />
        <Visible when={productsIds.length}>
          <SortingComponent
            sortBy={sortPayload?.sortBy}
            sortOrder={sortPayload?.sortOrder}
            type="name"
            handleSorting={handleSorting}
          />
        </Visible>
      </>
    ),
    accessor: 'nameDescription',
    Cell: (props) => <ProductDescription {...props} />,
  },
  {
    Header: (
      <>
        <Message message={messages.product} literal />
        <Visible when={productsIds.length}>
          <SortingComponent
            sortBy={sortPayload?.sortBy}
            sortOrder={sortPayload?.sortOrder}
            type="product"
            handleSorting={handleSorting}
          />
        </Visible>
      </>
    ),
    accessor: 'product',
  },
  {
    Header: <Message message={messages.status} literal />,
    accessor: 'status',
    Cell: (props) => <ProductStatus {...props} />,
  },
  {
    Header: (
      <>
        <Message message={messages.lastModified} literal />
        <Visible when={productsIds.length}>
          <SortingComponent
            sortBy={sortPayload?.sortBy}
            sortOrder={sortPayload?.sortOrder}
            type="lastModified"
            handleSorting={handleSorting}
          />
        </Visible>
      </>
    ),
    accessor: 'lastModified',
  },
  {
    Header: <Message message={messages.actions} literal />,
    accessor: 'actions',
    Cell: (props) => <ActionsCell {...props} />,
  },
  {
    id: 'expander',
    Cell: ({ row, rows }) => {
      const toggleRowExpanded = () => {
        rows.forEach((r) => {
          if (r.id !== row.id && r.isExpanded) {
            r.toggleRowExpanded(false);
          }
        });
        row.toggleRowExpanded();
      };

      return (
        <span
          onClick={toggleRowExpanded}
          style={{ cursor: 'pointer' }}
          className={clsx({
            'icon-16-minus-mono': row.isExpanded,
            'icon-16-plus-mono': !row.isExpanded,
            'color-blue': true,
          })}
        />
      );
    },
    sortable: false,
  },
];
